import React, { useEffect } from 'react'
// import "../../../css/landing-page.css";
import whatsappImg from "../../../assets/whatsappContactUsImg.png";
import emailImg from "../../../assets/emailContactUsImg.png";
import amicoImg from "../../../assets/amico.png";
import { Link } from 'react-router-dom';

function Contact() {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div class="mx-16 xl:m-auto max-w-[93rem]">
      <div class="flex justify-center font-semibold text-30 xl:text-40 max-xs:text-[23px] underline decoration-solid text-[#523880] pt-16 font-sans">Contact Us</div>
      <div class="flex flex-col md:flex-row justify-center items-center gap-44 max-xs:gap-8 xl:gap-[237px] pt-16 xl:pb-28 pb-[136px]">
        <div class="  flex flex-col gap-7 xl:gap-[73px]">
          <div class="w-[308px] h-[236px] xl:w-[371px] xl:h-[321px] rounded-[10px] border-solid border-[1px] xl:border-[0.5px] border-[#00000080] max-xs:border-[1px]">
            <div class="flex flex-col text-center  px-7 py-8 xl:px-10 xl:py-14">
              <div class="font-sans font-semibold text-20 xl:text-30 text-primary-500 leading-[24.38px] xl:leading-[40.85px] h-6 xl:h-[41px]">
                Brand & Advertisers
              </div>
              <div class="font-normal text-16 xl:text-20 font-sans pt-7 pb-6 xl:pt-7 leading-[21.79px] xl:leading-[27.24px] xl:h-[54px]">If you are a brand or advertiser <br></br>with campaign requirements,</div>
              <div class=" flex flex-col gap-[8px]">
                <div class="flex gap-[5px] justify-center items-center font-sans font-semibold text-16 xl:text-20 xl:h-[27px]"><img src={emailImg} alt="emailImg img" class="w-[18px] h-[18px]" />
                  <span>
                    <a class="text-black no-underline leading-[21.79px] h-[22px]"
                      href="mailto:Support@ttlmedia.in">support@ttlmedia.in</a>
                  </span>
                </div>
                <div class="flex gap-[5px] justify-center items-center  font-sans font-semibold text-16 xl:text-20 xl:h-[27px]"><img src={whatsappImg} alt="whatsappImg img " class="w-[18px] h-[18px]" />
                  <Link to="https://wa.me/+918484965525" target="_blank" rel="noreferrer" class="text-black no-underline leading-[21.79px] h-[22px]  ">
                    <span>8484965525</span>
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <div class="w-[308px] h-[260px] xl:w-[371px] xl:h-[327px] rounded-[10px] border-[1px] border-solid  border-[#00000080]">
            <div class="flex flex-col text-center  px-7 py-8 xl:p-10 ">
              <div class="font-sans font-semibold text-20 xl:text-30 text-primary-500 leading-[24.38px] xl:leading-[40.85px] xl:h-[82px] ">
                Creators & Talent<br></br> Partners
              </div>
              <div class="font-normal text-16 xl:text-20 font-sans  pt-7 pb-6 leading-[21.79px] xl:leading-[27.24px] xl:h-[54px] ">If you are an Creators or talent<br></br> partner,</div>
              <div class=" flex flex-col gap-[8px]">
                <div class="flex gap-[5px] justify-center items-center font-sans font-semibold text-16 xl:text-20 xl:h-[27px]"><img src={emailImg} alt="emailImg img" class="w-[18px] h-[18px]" />
                  <span> <a class="text-black no-underline leading-[21.79px] h-[22px] "
                    href="mailto:influencer.support@ttlmedia.in"
                  >  help@oyecreator.in</a></span>
                </div>
                <div class="flex gap-[5px] justify-center items-center font-sans font-semibold text-16 xl:text-20 xl:h-[27px]"><img src={whatsappImg} alt="whatsappImg img" class="w-[18px] h-[18px]" />
                  <Link to="https://wa.me/+918484965525" target="_blank" rel="noreferrer" class="text-black no-underline leading-[21.79px] h-[22px] ">
                    <span >8484965525</span>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <img class="w-[392px] h-[442px] xl:w-[450px] xl:h-[507px] max-xs:w-[250px] max-xs:h-[230px]" src={amicoImg} alt="amicoImg img" />
        </div>
      </div>
    </div>
  );
}

export default Contact;